import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import PharmacyList from '../components/pharmacy/PharmacyList';
import { CityStatistics } from './index';
import { Layout } from '../components';
import { canonicalUrl } from '../utils/canonicalUrl';

type Props = {
  data: {
    allStatistics: {
      nodes: Array<{
        cities: CityStatistics[];
      }>;
    };
  };
};

const PharmacyPage: React.FunctionComponent<Props> = ({ data }) => {
  const statsNode =
    (data && data.allStatistics && data.allStatistics.nodes && data.allStatistics.nodes[0]) || undefined;
  const cities = (statsNode && statsNode.cities) || [];
  return (
    <>
      <Helmet>
        <title>Verkkoapteekit | Treet-verkkoapteekki</title>
        <meta name="description" content="Mistä löydän Treet verkkoapteekit? Linkkejä Treet verkkoapteekkeihin." />
        <link rel="canonical" href={canonicalUrl('/verkkoapteekit')} />
      </Helmet>
      <Layout>
        <PharmacyList cities={cities} />
      </Layout>
    </>
  );
};

export default PharmacyPage;

export const query = graphql`
  query ApteekitStatisticsQuery {
    allStatistics {
      nodes {
        cities {
          city
          pharmacies {
            name
            slug
            city
            url
            street_address
            postal_code
            phone_number
            has_webshop
            offers_delivery
            offers_pickup_box
            logo_url
            opening_hours {
              day_of_week
              open_from
              open_until
              delivers_from
              delivers_until
            }
          }
        }
      }
    }
  }
`;
